import { IconChevronLeft, IconTrash } from '@tabler/icons-react'
import { useEffect } from 'react'

import { AstraButton, AstraIcon, AstraTextArea } from '~/astra'

type Props = {
    note: string
    setNote: (note: string) => void
    updateNote: () => void
    deleteNote: () => void
    undoNote: () => void
    disabled?: boolean

    // This is necessary because LocationNote uses the modal in Table component, which has a close icon top right, so we need to move trash icon a bit to the left
    // This is a workaround, but once LocationTable and PractitionerTable are merged, we can remove this
    extraTrashIconPadding?: boolean
}

export const Note = ({ deleteNote, undoNote, note, setNote, updateNote, disabled, extraTrashIconPadding }: Props) => {
    function handleSaveNote() {
        updateNote()
    }

    useEffect(() => {
        function handleKeyDown(e: KeyboardEvent) {
            if (e.key === 'Enter' && !e.shiftKey) {
                e.preventDefault()
                updateNote()
            } else if (e.key === 'Escape') {
                e.preventDefault()
                e.stopPropagation()
                undoNote()
            }
        }

        document.body.addEventListener('keydown', handleKeyDown, { capture: true })

        return () => {
            document.body.removeEventListener('keydown', handleKeyDown, { capture: true })
        }
    }, [updateNote, undoNote])

    return (
        <div>
            <div className={`flex w-full items-center justify-between border-b py-2 ${extraTrashIconPadding ? 'pr-6' : 'pr-2'}`}>
                <div className="flex items-center space-x-2">
                    <AstraButton variant="ghost" onClick={handleSaveNote} disabled={disabled} icon={<AstraIcon icon={IconChevronLeft} />} />
                    <p className="text-center font-medium">Notat</p>
                </div>
                <AstraButton variant="ghost" onClick={deleteNote} disabled={disabled} icon={<AstraIcon icon={IconTrash} />} />
            </div>

            <AstraTextArea
                placeholder="Skriv her"
                value={note}
                onInput={e => setNote(e.currentTarget.value)}
                autoFocus
                rows={4}
                onFocus={e => e.target.setSelectionRange(e.target.value.length, e.target.value.length)}
                disabled={disabled}
                borderless
            />

            <div className="flex items-center justify-end space-x-2 bg-gray-100 p-2">
                <AstraButton onClick={undoNote} disabled={disabled} label="Avbryt" variant="critical" />
                <AstraButton onClick={handleSaveNote} disabled={disabled} label="Lagre" />
            </div>
        </div>
    )
}
